import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate} from 'react-router-dom';
import { loginRequest } from '../authConfig'; 
import { useMsal } from '@azure/msal-react';

export const Home = () => {
    const navigate = useNavigate();
    const { instance } = useMsal();

    const handleRequestAccess = () => {
        navigate('/request-access');
    };
    const handleLoginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    return (
        <Container>
            <Row>
                <Col md={8}>
                    <div style={{ backgroundColor: '#f8f9fa', padding: '30px', borderRadius: '10px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                        <h2>Welcome to the AgencyHub</h2>
                        <p>This is the new Agency portal. Here you can find all the information you need about the migration process and what changes to expect.</p>
                        <p style={{ display: 'none' }}>Make sure to check out our migration guide to get up to speed.</p>
                        <p>If you have already successfully activated your Agency Hub account, use the 
                            <span onClick={handleLoginRedirect} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', marginLeft: '5px' }}>
                                Sign In 
                            </span> 
                            &nbsp;here, or Sign In at the top right corner and sign in with the login credentials created during account activation.
                        </p>
                    </div>                    
                </Col>
                <Col md={4}>
                    <div style={{ backgroundColor: '#f8f9fa', padding: '30px', borderRadius: '10px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                        <h2>Are You an Agency of United Way Los Angeles?</h2>
                        <p>If you are associated with United Way Los Angeles and need access, please click the button below to request access.</p>
                        <Button variant="primary" onClick={handleRequestAccess}>
                            Request Access
                        </Button>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Home;
